import { useTranslation } from 'react-i18next';

interface PromptAIHelpButtonProps {
  profile?: string | null;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  testId?: string;
}

export default function PromptAIHelpButton({
  profile,
  onClick,
  disabled = false,
  loading = false,
  testId = 'action-ai-help',
}: PromptAIHelpButtonProps) {
  const { t } = useTranslation();
  if (!profile?.trim()) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      aria-label={t('gen_aiHelp', 'AI 帮写')}
      className="h-9 px-2 rounded-full flex items-center gap-1 text-[11px] font-medium text-purple-500 bg-purple-50 transition-all duration-200 cursor-pointer active:scale-95 disabled:cursor-not-allowed disabled:opacity-40"
    >
      <i className={`${loading ? 'ri-loader-4-line animate-spin' : 'ri-magic-line'} text-xs`} />
      <span>{t('gen_aiHelp', 'AI 帮写')}</span>
    </button>
  );
}
